import { FC } from 'react';
import { PageTitle } from '../../../../rbts/layout/core';
import { View } from './components/View';

const ProductosPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Productos</PageTitle>
      <View />
    </>
  );
};

export { ProductosPage };
